import React, { useState } from 'react';
import Tippy from '@tippyjs/react';
import './TrackMenu.scss';
import { useTranslation } from 'react-i18next';
import {
  Delete,
  Duplicate,
  Edit,
  GetTrackFromDigital,
  GetTrackFromPhysical,
} from '../../../../constants/Operations';
import { ProductViewModes } from '@/utils/productStateUtils';

const TrackMenu = (props: any) => {
  const [visible, setVisible] = useState(false);
  const show = () => setVisible(true);
  const hide = () => setVisible(false);
  const { t } = useTranslation();
  const isChangeRequestMode =
    props.context?.productViewMode === ProductViewModes.ChangeRequest;

  const dropDownContent = (
    <div className="menu-container-track">
      {props.context.readonly ? (
        <div onClick={() => onClickHandler(Edit)} className="menu-item">
          <span className="icon fas fa-list blue-color"></span>
          <span className="item-text">{t('track.viewDetails')}</span>
        </div>
      ) : (
        <>
          {!isChangeRequestMode ? (
            <div
              onClick={() => onClickHandler(Duplicate)}
              className="menu-item"
            >
              <span className="icon fas fa-clone blue-color"></span>
              <span className="item-text">{t('track.duplicateTrack')}</span>
            </div>
          ) : null}
          {!isChangeRequestMode ? (
            <div
              onClick={() => onClickHandler(GetTrackFromDigital)}
              className="menu-item"
            >
              <span className="icon fas fa-cloud-download-alt blue-color"></span>
              <span className="item-text">
                {t('track.getTrackFromDigital')}
              </span>
            </div>
          ) : null}
          {!isChangeRequestMode ? (
            <div
              onClick={() => onClickHandler(GetTrackFromPhysical)}
              className="menu-item"
            >
              <span className="icon fas fa-compact-disc blue-color"></span>
              <span className="item-text">
                {t('track.getTrackFromPhysical')}
              </span>
            </div>
          ) : null}
          <div onClick={() => onClickHandler(Edit)} className="menu-item">
            <span className="icon fas fa-pencil blue-color"></span>
            <span className="item-text">{t('track.editDetails')}</span>
          </div>
          {!isChangeRequestMode ? (
            <div onClick={() => onClickHandler(Delete)} className="menu-item">
              <span className="icon fas fa-times blue-color"></span>
              <span className="item-text left-align">
                {t('track.deleteDetails')}
              </span>
            </div>
          ) : null}
        </>
      )}
    </div>
  );

  const onClickHandler = (option: any) => {
    hide();
    props.context.addRemoveTrack(props.data, option);
  };

  return (
    <Tippy
      content={dropDownContent}
      visible={visible}
      onClickOutside={hide}
      allowHTML={true}
      arrow={false}
      appendTo={document.body}
      interactive={true}
      placement="left"
    >
      <span
        className="icon fas fa-ellipsis-v action-menu-icon button-span track-action-cell-button"
        onClick={visible ? hide : show}
      ></span>
    </Tippy>
  );
};

export default TrackMenu;
